import { Controller } from "@hotwired/stimulus"

// L'anteprima di una bozza della domanda (openPreview / closePreview di components/readiness/ApplicationPrep.js,
// 31a5bd1): la finestra "pdf-preview" (dialog_controller) si apre subito con il nome e il Loader2, il file si legge con
// fetch dalla stessa origine (la sessione a cookie) e il blob va nell'iframe. Se non si legge: la finestra si chiude e
// toast.error «Anteprima non disponibile.». Alla chiusura l'indirizzo del blob si revoca dopo 30 s, come l'originale.
// Nessuno script nella pagina: l'iframe mostra il blob, mai l'indirizzo del file. Il blob ha il tipo della risposta: il
// file della bozza arriva in linea solo come application/pdf (senza la CSP sandbox, che fermerebbe il lettore PDF: vedi
// InvioFile), ogni altro tipo come application/octet-stream, quindi mai un documento HTML. Nessun `sandbox` sull'iframe:
// spegnerebbe il lettore PDF di Chrome.
//   <div data-controller="anteprima-bozza" data-action="dialog:closed->anteprima-bozza#chiuso">
//     <button data-action="anteprima-bozza#apri" data-anteprima-bozza-url-param="/api/…/file" data-anteprima-bozza-nome-param="Modulo.pdf">
//     … ui_dialog id "pdf-preview" con i target titolo, frame, attesa
export default class extends Controller {
  static targets = ["titolo", "frame", "attesa"]
  static values = { dialog: { type: String, default: "pdf-preview" } }

  disconnect() {
    this.rilascia()
  }

  async apri({ params: { url, nome } }) {
    const n = (this.richiesta = (this.richiesta || 0) + 1)
    this.rilascia()
    this.titoloTarget.textContent = `${nome} · anteprima bozza`
    this.mostraFile(false)
    this.finestra("dialog:open")
    try {
      const indirizzo = new URL(url, window.location.href)
      if (indirizzo.origin !== window.location.origin) throw new Error("Anteprima da un'altra origine rifiutata")
      const res = await fetch(indirizzo.href, { credentials: "same-origin" })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const blob = await res.blob()
      if (n !== this.richiesta) return
      this.blobUrl = URL.createObjectURL(blob)
      this.frameTarget.src = this.blobUrl
      this.mostraFile(true)
    } catch (e) {
      if (n !== this.richiesta) return
      this.finestra("dialog:close")
      window.toast?.error?.("Anteprima non disponibile.")
    }
  }

  // la finestra chiusa (Esc, overlay, X): niente più file nell'iframe
  chiuso(event) {
    if (event.target?.id !== `dialog-${this.dialogValue}`) return
    this.richiesta = (this.richiesta || 0) + 1
    this.rilascia()
    this.frameTarget.removeAttribute("src")
    this.mostraFile(false)
  }

  rilascia() {
    if (!this.blobUrl) return
    const u = this.blobUrl
    this.blobUrl = null
    setTimeout(() => URL.revokeObjectURL(u), 30000)
  }

  mostraFile(si) {
    this.frameTarget.hidden = !si
    this.attesaTarget.hidden = si
  }

  finestra(evento) {
    window.dispatchEvent(new CustomEvent(evento, { detail: { id: this.dialogValue } }))
  }
}
